// (c) TwistedMinds, Gerry Uytdenhouwen - 5 november 2026

const EMAIL_CHANGE_PREFIX = '#besteller-email=';

/**
 * Reads the e-mail change confirmation token from a location hash.
 * Only the exact format `#besteller-email=<urlencoded token>` is accepted;
 * any other hash (the shop's own anchors) returns null.
 *
 * @param {string} hash
 * @returns {{token: string}|null}
 */
export const parseEmailChangeFragment = (hash) => {
    if (typeof hash !== 'string' || !hash.startsWith(EMAIL_CHANGE_PREFIX)) {
        return null;
    }
    const params = new URLSearchParams(hash.slice(1));
    const token = params.get('besteller-email');
    if (!token) {
        return null;
    }
    return {token};
};
